module.exports = __webpack_public_path__ + "img/bottom-left.3c738b19.jpg";